import { useLocation } from "react-router-dom";
import { useStore } from "store";
import { StoreType } from "store/types";
import { authorization } from "module/auth";

/**
 * Returns `true` when the flyer-builder empty-state overlay is visible
 * (no flyer type selected or the `?newDesign=true` query param is set).
 *
 * Use this to guard interactions that should be blocked while the
 * overlay is on screen (sidebar clicks, drag-and-drop, toolbar, etc.).
 *
 * Guests skip the format-selector empty state on first entry and land
 * directly on a TEARAWAY canvas with marketing placeholders. The
 * `?newDesign=true` flag (set by the "+ New Design" sidebar button) is
 * still honoured so a guest can opt into the format selector explicitly.
 */
export function useIsBuilderEmptyState(): boolean {
  const {
    campaign: { flyerType },
  }: StoreType = useStore();

  // Read the search via useLocation so consumers re-render when the
  // sidebar toggles ?newDesign=true via history.replace.
  const location = useLocation();
  const isNewDesign = new URLSearchParams(location.search).get("newDesign") === "true";
  const isGuest = !authorization.getUser?.()?.id;

  if (isGuest && !isNewDesign) return false;
  return !flyerType || isNewDesign;
}
